export class QuickInvoiceFilter {
  constructor(sortColumn, sortOrder, pageIndex = 1, pageSize = 18) {
    this.invoiceNo = ''
    this.assetName = ''
    this.dateFrom = ''
    this.dateTo = ''
    this.sortColumn = sortColumn
    this.sortOrder = sortOrder
    this.pageIndex = pageIndex
    this.pageSize = pageSize
  }
}
